import { useDatatablesServerSide } from "App/hooks";
import { defaultToastError } from "App/utils/helpers";
import { useContext, useState } from "react";
import { getBundle, RESET_STATE_HEADER } from "../helpers";
import { BundleCtx } from "../../context/context";
import { changeBundle, changeLoading } from "../../context/actions";

function useReloadTableBundle() {
	const { state, dispatch } = useContext(BundleCtx);

	const [formFilter, setFormFilter] = useState(RESET_STATE_HEADER);

	const handleChange = (text) => (e) => {
		setFormFilter({
			...formFilter,
			[text]: e.target.value,
		});
	};

	const setNewData = async (
		pages = formFilter.pages,
		limit = formFilter.limit,
		formSearch = formFilter
	) => {
		dispatch(changeLoading(true));
		const response = await getBundle(formSearch, pages, limit);
		if (response.state) {
			dispatch(
				changeBundle({
					state: response.status,
					message: response.message,
					data: response.data,
					count: response.count,
					sisa: response.sisa,
					limit: response.limit,
					pages: response.pages,
				})
			);
			dispatch(changeLoading(false));
		} else {
			dispatch(
				changeBundle({
					state: "",
					message: "",
					data: [],
					count: 1,
					sisa: true,
					limit: 10,
					pages: 1,
				})
			);
			dispatch(changeLoading(false));
			defaultToastError(response.message);
		}
	};

	const {
		pagination,
		onNext,
		onPrevious,
		handleClickPageNumber,
		handleChangeLimit,
		resetPagination,
	} = useDatatablesServerSide({
		setNewData: setNewData,
		additionalProps: formFilter,
	});

	return {
		setNewData,
		loading: state.loading,
		handleChange,
		formFilter,
		setFormFilter,
		pagination,
		onNext,
		onPrevious,
		handleClickPageNumber,
		handleChangeLimit,
		resetPagination,
	};
}

export default useReloadTableBundle;
